import { navLinks } from "@/mocks/home";

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-background-100">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-16">
        <div className="grid gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-translate-2 text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-lg font-semibold text-background-50">
                日韩中文字幕
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-200">
              一个面向片荒观众的日韩中文字幕资源指南。我们把日剧、韩剧、电影与动画的合集、榜单与精选整理成
              清晰的页面，帮你在海量资源里更快挑到想看的作品。
            </p>
          </div>

          <div className="md:col-span-3">
            <h3 className="font-heading text-sm font-semibold text-background-50">页面导航</h3>
            <ul className="mt-4 space-y-2.5">
              {navLinks.map((link) => (
                <li key={link.id}>
                  <a
                    href={`#${link.id}`}
                    className="text-sm text-background-200 transition-colors hover:text-background-50 cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h3 className="font-heading text-sm font-semibold text-background-50">使用说明</h3>
            <ul className="mt-4 space-y-2.5 text-sm text-background-200">
              <li className="flex items-start gap-2">
                <i className="ri-information-line mt-0.5" aria-hidden="true"></i>
                站内介绍与榜单仅作选片参考，不提供实际影片文件。
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-bookmark-line mt-0.5" aria-hidden="true"></i>
                喜欢的合集可以记住名称，方便下次快速找回。
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-refresh-line mt-0.5" aria-hidden="true"></i>
                榜单与合集每周整理更新一次。
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-primary-700 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-background-300">
            © {new Date().getFullYear()} 日韩中文字幕指南 · 内容整理页面
          </p>
          <a
            href="#top"
            className="inline-flex items-center gap-1.5 text-xs text-background-200 transition-colors hover:text-background-50 cursor-pointer"
          >
            <i className="ri-arrow-up-line" aria-hidden="true"></i>
            回到顶部
          </a>
        </div>
      </div>
    </footer>
  );
}